<template>
    <div class="ma-4">
        <delete-note-dialog
            ref="dialog"
            title="Removing..."
            @openDialog="archiveInventory"
            @on-submit="inventoryArchive"
        />
        <v-snackbar v-model="msg" top>
            {{ text }}
            <v-btn color="pink" text @click="msg = false"> Close</v-btn>
        </v-snackbar
        >
        <ClientNav class="hideOnPrint"/>
        <v-row dense class="hideOnPrint">
            <v-col cols="12" lg="3" xl="2">
                <ClientSide/>
            </v-col>
            <v-col cols="12" lg="9" xl="10">
                <v-card class="pa-2" outlined tile height="100%">
                    <v-tabs v-model="tab">
                        <v-tabs-slider color="yellow"></v-tabs-slider>
                        <v-tab v-for="(item, index) in items" :key="index">
                            {{ item }}
                            <v-chip class="ml-2" color="green" text-color="white" small>
                                {{ index === 0 ? activeInventory : discontinued }}
                            </v-chip>
                        </v-tab>
                    </v-tabs>

                    <v-tabs-items v-model="tab">
                        <v-tab-item v-for="(item, i) in items" :key="item">
                            <v-card class="pa-2" outlined tile height="100%">
                                <template>
                                    <v-data-table
                                        :headers="i === 0 ? headers : discontinuedHeader"
                                        :items="i === 0 ? inventories : discontinuedInventories"
                                        sort-by="DateAdded"
                                        sort-desc
                                        :loading="isLoading"
                                        loading-text="Loading Inventory"
                                        :search="search"
                                        height="550"
                                    >
                                        <template v-slot:top>
                                            <v-toolbar flat color="white">
                                                <v-toolbar-title>{{
                                                        i === 0 ? "Inventory" : "Discontinued Inventory"
                                                    }}
                                                </v-toolbar-title>
                                                <v-divider class="mx-4" inset vertical></v-divider>
                                                <v-spacer></v-spacer>
                                                <v-text-field
                                                    v-model="search"
                                                    clearable
                                                    flat
                                                    solo-inverted
                                                    hide-details
                                                    prepend-inner-icon="search"
                                                    label="search"
                                                    class="desktop"
                                                ></v-text-field>
                                                <v-spacer></v-spacer>
                                                <v-btn
                                                    fab
                                                    small
                                                    @click="printTable()"
                                                    class="mr-8 mb-2 white--text"
                                                    color="#2b6993"
                                                    elevation="4"
                                                    v-if="!directCare && i === 0"
                                                >
                                                    <v-icon>print</v-icon>
                                                </v-btn>
                                                <v-btn
                                                    v-if="i === 0 && !isAuditorRole"
                                                    color="#2b3990"
                                                    dark
                                                    class="mb-2"
                                                    @click="showAdd()"
                                                >
                                                    <v-icon left>add</v-icon>
                                                    Add Inventory
                                                </v-btn>
                                            </v-toolbar>
                                            <v-text-field
                                                v-model="search"
                                                clearable
                                                flat
                                                solo-inverted
                                                hide-details
                                                prepend-inner-icon="search"
                                                label="search"
                                                class="mobile ml-5 mr-5 mb-3 mt-3"
                                            ></v-text-field>
                                        </template>

                                        <template v-slot:item.actions="{ item }">
                                            <v-icon small class="mr-2" @click="viewInventory(item)">
                                                mdi-eye
                                            </v-icon>
                                            <v-icon
                                                small
                                                @click="archiveInventory(item)"
                                                v-if="canDelete && i === 0"
                                            >
                                                mdi-trash-can
                                            </v-icon>

                                            <!-- <v-icon small @click="addDeal(item)">
                                        add
                                      </v-icon> -->
                                        </template>
                                        <template v-slot:no-data>
                                            <v-btn
                                                color="#2b3990"
                                                class="white--text"
                                                @click="getInventories()"
                                            >Reset
                                            </v-btn
                                            >
                                        </template>
                                    </v-data-table>
                                </template>
                            </v-card>
                        </v-tab-item>
                    </v-tabs-items>
                </v-card>
            </v-col>
        </v-row>
        <Foot class="hideOnPrint"/>

        <div id="printTable">
            <h2 class="text-center ma-3">{{clientName}} Inventory</h2>
            <v-row>
                <v-col cols="12">
                    <v-data-table
                        :headers="printHeaders"
                        :items="inventories"
                        sort-by="DateAdded"
                        sort-desc
                        :loading="isLoading"
                        loading-text="Loading Inventory"
                        :search="search"
                        height="auto"
                        hide-default-footer
                        disable-pagination
                    >
                        <template v-slot:top>
                            <v-toolbar flat color="white">
                                <v-toolbar-title>Client Inventory</v-toolbar-title>
                            </v-toolbar>
                        </template>
                    </v-data-table>
                </v-col>
            </v-row>
        </div>
    </div>
</template>

<script>

/*eslint-disable */
import axios from "axios";
import ClientNav from "../../components/ClientNav";
import ClientSide from "../../components/ClientSide";
import Foot from "../../components/Footer";
import moment from "moment";
import DeleteNoteDialog from "@/components/shared/DeleteNoteDialog.vue";
// import LoadPDF from '../../components/LoadPDF.vue'
import SignaturePad from "@/components/SignaturePad";

import {mapActions} from "vuex";

const url = require("../../client_config/config").url;

export default {
    components: {
        ClientNav,
        ClientSide,
        DeleteNoteDialog,
        SignaturePad,
        Foot,
    },
    data: function () {
        return {
            headers: [
                {
                    text: "Date Added",
                    align: "start",
                    sortable: true,
                    value: "DateAdded",
                },
                {text: "Item", value: "Item"},
                {text: "Description", value: "Description"},
                {text: "Value", value: "Value"},
                {text: "EnteredBy", value: "EnteredBy"},
                {text: "Actions", value: "actions", sortable: false},
            ],

            discontinuedHeader: [
                {
                    text: "Date Removed",
                    align: "start",
                    sortable: true,
                    value: "deletedAt",
                },
                {text: "Item", value: "Item"},
                {text: "Description", value: "Description"},
                {text: "Value", value: "Value"},
                {text: "EnteredBy", value: "EnteredBy"},
                {text: "RemovedBy", value: "updatedBy"},
                {text: "Reason", value: "Reason"},
                {text: "Actions", value: "actions", sortable: false},
            ],
            printHeaders: [
                {
                    text: "Date Added",
                    align: "start",
                    sortable: true,
                    value: "DateAdded",
                },
                {text: "Item", value: "Item"},
                {text: "Description", value: "Description"},
                {text: "Value", value: "Value"},
                {text: "EnteredBy", value: "EnteredBy"},
            ],
            items: ["Inventory", "Discontinued Inventory"],
            date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
                .toISOString()
                .substr(0, 10),
            menu: false,
            menu2: false,
            dialog: false,
            editInventory: false,
            newInventory: false,
            msg: false,
            search: "",
            text: "",
            inventories: [],
            tempData: [],
            users: [],
            staff: "",
            clientID: this.$route.params.clientID,
            userID: localStorage.getItem("userID"),
            titleForm: "New Inventory Item",
            inventoryID: "",
            newDateAdded: "",
            newValue: "",
            newDescription: "",
            newImage: [],
            imageDetails: [],
            newImageLink: "",
            newEnteredBy: "",
            newClientSignature: "",
            inventorySignaturepad: false,
            newItem: "",
            canDelete: false,
            directCare: false,
            editedIndex: -1,
            editedItem: {
                dateAdded: "",
                description: "",
                value: "",
                image: "",
                enteredBy: "",
                clientSignature: "",
                item: "",
            },
            defaultItem: {
                dateAdded: "",
                description: "",
                value: "",
                image: "",
                enteredBy: "",
                clientSignature: "",
                item: "",
            },
            isLoading: true,
            uploadImg: "",
            tab: null,
            discontinuedInventories: [],
            tempDataInventories: [],
            showSignaturePad: false,
            digitalSignature: "",
        };
    },

    computed: {
        formTitle() {
            return this.editedIndex != 1 ? "New Item" : "Edit Item";
        },
        clientName() {
            // `this` points to the component instance
            return this.$store.state.clients.client.Name;
        },
        activeInventory() {
            return this.inventories.length;
        },
        discontinued() {
            return this.discontinuedInventories.length;
        },
        isAuditorRole() {
            return localStorage.getItem("userRole") === 'Auditor'
        }
    },

    watch: {
        dialog(val) {
            val || this.close();
        },
    },

    created() {
        this.getInventories();
        this.getUsers();
        this.getClientInfo(this.clientID);
        if (
            localStorage.getItem("userRole") == "Administration" ||
            localStorage.getItem("userRole") == "Client Services Manager" ||
            localStorage.getItem("userRole") == "Program Coordinator" ||
            localStorage.getItem("userRole") == "Human Resources" ||
            localStorage.getItem("userRole") == "Compliance Manager" ||
            localStorage.getItem("userRole") == "Program Manager"
        ) {
            this.canDelete = true;
        } else {
            this.canDelete = false;
        }
        if (localStorage.getItem("userRole") == "Direct Care Staff") {
            this.directCare = true;
        }
    },

    methods: {
        ...mapActions({
            getClientInfo: "clients/getClient",
        }),
        initialize() {
            this.inventories = [];
        },

        viewInventory(item) {
            console.log({item});
            this.$router.push({
                path: `/inventory/${this.clientID}/update/${item._id}`,
                query: {createInventory: false}
            })
        },

        showAdd() {
            this.$router.push({
                path: `/inventory/${this.clientID}/new`,
                query: {createInventory: true}
            })
        },

        archiveInventory(item) {
            this.inventoryID = item._id;
            this.$refs.dialog.openDialog();
        },

        inventoryArchive(note) {
            this.$refs.dialog.openDialog();
            axios
                .put(`${url}/inventory/archive/${this.inventoryID}`, {
                    reason: note,
                    deletedAt: new Date(),
                })
                .then((response) => {
                    this.getInventories();
                    if (response.status == 400) {
                        response.json().then(function (data) {
                            return data.msg;
                        });
                    }
                    this.msg = true;
                    this.text = "The inventory item has been deleted successfully.";
                });
        },

        getInventories() {
            this.isLoading = true;
            axios
                .get(`${url}/inventory/client/${this.clientID}`)
                .then((res) => {
                    this.discontinuedInventories = [];
                    this.inventories = [];
                    this.tempDataInventories = res.data.inventories;

                    this.inventories = this.tempDataInventories.filter(
                        (item) => item.isDeleted === false || item.isDeleted === undefined
                    ).map((item) => {
                        return {
                            ...item,
                            DateAdded: this.dateCheck(item.DateAdded, "YYYY-MM-DD")
                        }
                    })

                    this.discontinuedInventories = this.tempDataInventories
                        .filter((item) => item.isDeleted === true)
                        .map((date) => {
                            if (!date.hasOwnProperty("deletedAt")) {
                                return Object.assign({}, date, {
                                    deletedAt: date.hasOwnProperty("updatedAt")
                                        ? date.updatedAt
                                        : null,
                                });
                            } else {
                                return date;
                            }
                        }).map(item => {
                            return {
                                ...item,
                                deletedAt: this.dateCheck(item.deletedAt, "YYYY-MM-DD")
                            }
                        });
                })
                .finally(() => (this.isLoading = false));
        },

        getUsers: function () {
            axios.get(`${url}/users`).then(async (res) => {
                this.users = res.data.users;
                for (var i = 0; i < this.users.length; i++) {
                    if (this.userID == this.users[i]._id) {
                        this.staff = this.users[i].Name;
                    }
                }
                this.newEnteredBy = this.staff + " - " + new Date();
            });
        },


        printTable() {
            // document.getElementById("printTable").style.display = "block";
            // document.getElementById("printItem").style.display = "none";

            // window.print();
            const printTableElement = document.getElementById("printTable");
            const printItemElement = document.getElementById("printItem");

            if (printTableElement && printTableElement.style) {
                printTableElement.style.display = "block";
            } else {
                console.error("Unable to access 'style' property of printTableElement.");
            }

            if (printItemElement && printItemElement.style) {
                printItemElement.style.display = "none";
            } else {
                console.error("Unable to access 'style' property of printItemElement.");
            }

            window.print();
        },

        printItem() {
            document.getElementById("printItem").style.display = "block";
            document.getElementById("printTable").style.display = "none";

            window.print();
        },

        dateCheck(date, format) {
            return date !== "Invalid date" && date !== ""
                ? moment(String(date)).format(format)
                : "";
        },
    },
};
</script>
<style>
@media only screen and (min-width: 768px) {
    .mobile {
        display: none;
    }
}

@media only screen and (max-width: 600px) {
    .desktop {
        display: none;
    }
}

#printTable {
    display: none;
}

#printItem {
    display: none;
}

@media only screen and (min-width: 768px) {
    .mobile {
        display: none;
    }
}

@media only screen and (max-width: 600px) {
    .desktop {
        display: none;
    }
}

@media print {
    #printTable {
        display: block;
        border: none;
        width: 1200px;
        padding-right: 300px;
        margin-left: -200px;
    }

    #printItem {
        display: block;
        border: none;
        width: 1200px;
        padding-right: 300px;
        margin-left: -200px;
    }

    .hideOnPrint {
        display: none;
        border: none;
    }

    nav.v-navigation-drawer,
    header.v-toolbar,
    button.v-btn,
    div.v-card {
        display: none;
        border: none;
    }

    @page {
        margin: 0;
    }

    body {
        margin: 1.6cm;
    }
}

</style>
